import { Controller } from 'stimulus';

// Shows a section only while a switch is on, and inerts controls that need the section
// live (e.g. a Preview button). Anything that must stay usable while the section is
// hidden — a Save button that persists the switch itself — simply is not a target, and
// lives outside the body element.
//
// Callers server-render the correct state, so this only handles changes after boot;
// connect() re-syncs defensively in case Turbo restores a cached DOM.
export default class extends Controller {
  static targets = ['toggle', 'body', 'gated'];

  connect() {
    this.sync();
  }

  toggled() {
    this.sync();
  }

  sync() {
    // Reads the target, not [name="…"]: UI::Switch's app variant renders a hidden
    // companion input under the same name *before* the real checkbox, so a name lookup
    // finds the wrong node.
    const on = this.hasToggleTarget && this.toggleTarget.checked;
    this.bodyTargets.forEach((element) => {
      element.classList.toggle('hidden', !on);
    });
    this.gatedTargets.forEach((element) => {
      element.disabled = !on;
    });
  }
}
